import React from 'react';
import ChangeLang from './ChangeLang';
import ChangeTemp from './ChangeTemp';
import RefreshImg from './RefreshImg';
import Search from './Search';

const Header = (props) => {
  const {
    getMainImage,
    getLanguageDayWeeks,
    changeTemperature,
    weather,
    getSearchCity,
    lang,
    deg
  } = props.data;
  return (
    <div className="header">
      <div className="controls">
        <RefreshImg func={getMainImage} />
        <ChangeLang data={{ func: getLanguageDayWeeks, language: lang }} />
        <ChangeTemp data={{ func: changeTemperature, temperature: weather, degree: deg }} />
      </div>

      <Search data={{ func:getSearchCity, language: lang}} />
    </div>
  );
};

export default Header;
